import { PAGE_COUNTRY_SCORE_CARD, PAGE_HOMEPAGE, PAGE_NONE } from "../constants";
import SubPage from "../SubPage";
import Utils from "../Utility/Utils";
import MobilePolicyScoreGraph from "./mobileClasses/mobilePolicyScoreGraph";
import PolicyDataCalculation from "./PolicyDataCalculation";
import PolicyScoreGraph from "./PolicyScoreGraph";

export default class PolicySimulator {

    // Private static property to hold the singleton instance
    static instance = null;

    // The constructor is now private to prevent external instantiation
    constructor(data) {
        if (PolicySimulator.instance) {
            return PolicySimulator.instance; // Return the existing instance if it exists
        }

        this.data = data;
        this.dropdownElement = $("#selectCountry2");
        this.backBtn = document.querySelector('#policy-simulator .top-row .selectContext .backBtn');
        this.resetBtn = document.querySelector('#policy-simulator .bottom-row .graph-block .resetBtn');
        this.ctaBtn = window.innerWidth <= 992 ? document.querySelector('#policy-simulator .mobile-cta .cta_btn') : document.querySelector('#policy-simulator .top-row  .cta_btn');

        this.isPortrait = window.innerWidth <= 992

        this.policyScoreGraph = null;
        this.groupRanges = [
            { group: "Human", keys: ["Human_capital", "Percent_of_population", "Suicide_mortality", "Age_dependency_ratio", "Life_expectancy"] },
            { group: "Physical", range: ["Physical_capital", "World_Bank_logistics", "Access_to_electricity", "Individuals_using_internet", "Secure_internet"] },
            { group: "Social", range: ["Trust"] },
            { group: "Natural", range: ["Natural_capital", "PM2_5", "Water_stress"] },
            { group: "Innovation", range: ["Hirschman_Index", "Patent_applications", "Science_journal"] },
            { group: "Institution", range: ["World_Bank_institutional", "Inequality_principal"] }
        ];

        this.topCountries = null;

        this.policyData = new PolicyDataCalculation(this.data);
        this.processCountries = this.policyData.processCountries(this.groupRanges);

        if (this.processCountries != null) {
            this.topCountries = this.policyData.getTopCountriesByCategory(this.data, this.groupRanges);
        }

        this.distanceToFrontier = this.policyData.calculateDistanceToFrontier(this.data, this.groupRanges);    
        // Initialize the singleton instance
        PolicySimulator.instance = this;


        this.init();
    }

    static getInstance(data) {
        if (!PolicySimulator.instance) {
            // Create the instance if it does not exist
            new PolicySimulator(data);
        }
        return PolicySimulator.instance;
    }
 
    init() {
        if (!this.dropdownElement) {
            console.error("Dropdown element not found!");
            return;
        }

        

        if (!this.data || !Array.isArray(this.data)) {
            console.error('Invalid data format for population:', this.data);
            return;
        } else {
            this.addCountryDropdown(this.data); // Populate the dropdown
            if (window.innerWidth <= 992) {
                this.policyScoreGraph = new MobilePolicyScoreGraph(document.querySelector('#policy-chart-area'), this.processCountries, this.topCountries, this.distanceToFrontier)
                
            } else {
                this.policyScoreGraph = new PolicyScoreGraph(document.querySelector('#policy-chart-area'), this.processCountries, this.topCountries, this.distanceToFrontier);
            }

            $('.ui.dropdownPolicy').on('change', () => {
                this.policyScoreGraph.resetGraph();
                this.policyScoreGraph.updateGraph($('.ui.dropdownPolicy').dropdown('get value'));
            })
            
                
        } 

        this.backBtn.addEventListener('click', () => {
            if(window.menuHistory.goBack() == null){
                this.isPortrait ? SubPage.handleMobileActiveState(0) : SubPage.handleActiveState(1)
            } else {
                this.isPortrait ? SubPage.handleMobileActiveState(1) : SubPage.handleActiveState(2)
            }

            SubPage.getInstance().hidePolicySimulatorPage();
        });
 
        this.resetBtn.addEventListener('click', () => {
            this.policyScoreGraph.resetGraph();
        });

         this.ctaBtn.addEventListener('click', () => {
            SubPage.getInstance().showPolicyImplicationsPage()
        })
    } 

    // Dynamically add countries to the dropdown
    addCountryDropdown(data) {
        if (!data || !Array.isArray(data)) {
            console.error('Invalid data format for dropdown population:', data);
            return;
        }

        data.sort((a, b) => {
            if (a.Country.toLowerCase() < b.Country.toLowerCase()) return -1;
            if (a.Country.toLowerCase() > b.Country.toLowerCase()) return 1;
            return 0;
        });

        data.forEach((country) => {
            this.dropdownElement.find('.menu').append(`<div class="item" data-value="${country.Country}"><i class="${country.Code.toLowerCase()} flag"></i>${country.Country}</div>`)          
        });
    }
}
